// @docs https://[domain]/api/v1/docs
export default {
  List: "/pyr/group-machines",
  Short: "/pyr/group-machines/short",
  Detail: "/pyr/group-machines",
  Create: "/pyr/group-machines",
  Update: "/pyr/group-machines",
  Delete: "/pyr/group-machines",
};
